import { TRIAL_LENGTH_DAYS, TRIAL_PAGE_GRANT } from '@/modules/account'
import { TrialDemoVideo } from './TrialDemoVideo'
import { ValueProps } from './ValueProps'

export const TrialPitch = () => (
  <section aria-labelledby="trial-heading" className="flex flex-col gap-8">
    <TrialDemoVideo />
    <div className="flex flex-col gap-4">
      <h1
        id="trial-heading"
        className="text-3xl font-semibold tracking-tight text-balance sm:text-4xl"
      >
        Get a free {TRIAL_LENGTH_DAYS} day trial of CounselPro
      </h1>
      <p className="text-base text-muted-foreground text-pretty sm:text-lg">
        Up to {TRIAL_PAGE_GRANT} pages processed risk-free, upgrade at any time.
      </p>
    </div>
    <ValueProps className="hidden gap-5 lg:grid" />
  </section>
)
